import { RELEVANT_TO_ME_ID } from "PFApp/constants/relevant_to_me";
import { PageTarget } from "PFTypes/saved_filters";

export const savedFiltersKeys = {
  all: () => ["savedFilters"],
  target: (target: PageTarget) => [...savedFiltersKeys.all(), target],
  relevantToMe: (target: PageTarget) => [RELEVANT_TO_ME_ID, target]
};
